export const chatbotQueryKeys = {
	conversations: ["chatbot-conversations"] as const,
	instructions: ["chatbot-instructions"] as const,
	limits: ["chatbot-limits"] as const,
};
